module.exports = __webpack_public_path__ + "static/media/filter-icon.aba73251.png";